import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from 'app/core/modules/shared.module';

import { NgxPermissionsGuard } from 'ngx-permissions';
import { FuseWidgetModule } from 'app/core/components/widget/widget.module';
import { AgmCoreModule } from '@agm/core';
import { environment } from '../../../../../../environments/environment';
import { StudentService } from '../../../../services/students/student.service';
import { PersonGenderService } from '../../../../services/person-genders/person-gender.service';
import { DivisionService } from '../../../../services/divisions/division.service';
import { RelationshipService } from '../../../../services/relationships/relationship.service';
import { TutorService } from '../../../../services/tutors/tutor.service';
import { ReportService } from '../../../../services/reports/report.service';
import { LightboxModule } from 'ngx-lightbox';
import { SubjectComponent } from './subject.component';
import { AddSubjectComponent } from './components/add-subejct/add-subject.component';
import { SubjectService } from '../../../../services/subject/subject.service';

const routes = [
    {
        path: 'pages/management/subjects/:id',
        component: SubjectComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_MANAGEMENT_SUBJECTS',
                redirectTo: '/pages/errors/error-403'
            }
        }
    },
    {
        path: 'pages/management/subjects',
        component: SubjectComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_MANAGEMENT_SUBJECTS',
                redirectTo: '/pages/errors/error-403'
            }
        }
    },
    {
        path: 'pages/management/subjects/:id',
        component: SubjectComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_MANAGEMENT_SUBJECTS',
                redirectTo: '/pages/errors/error-403'
            }
        }
    }
];

@NgModule({
    declarations: [
        SubjectComponent,
        AddSubjectComponent,
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        FuseWidgetModule,
        LightboxModule,
        AgmCoreModule.forRoot({
            apiKey: environment.googleMapsApiKey
        })
    ],
    exports: [
        SubjectComponent
    ],
    entryComponents: [
        AddSubjectComponent,
    ],
    providers: [
        StudentService,
        PersonGenderService,
        DivisionService,
        RelationshipService,
        TutorService,
        ReportService,
        SubjectService
    ]
})

export class SubjectModule {
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/subjects/subject.module.ts